export default "__VITE_ASSET__$8Ds5mN___"